<div class="grid-header">
    
    <table class="grid-header-month" *ngIf="headerMonth" [style.width.px]="cellWidth * header.length">
        <tr>
            <td class="td-top" *ngFor="let month of headerMonth" [style.width.px]="cellWidth * month.value">
                {{month.name}}
            </td>
        </tr>
    </table>

    <table *ngIf="header" [style.width.px]="cellWidth * header.length">
        <tr>
            <td class="td-bot" *ngFor="let cell of header" [style.width.px]="cellWidth">
                <span class="text-cell thin">{{cell}}</span>
            </td>
        </tr>
    </table>
</div>
